import { useNavigate } from "react-router-dom";
import "./restaurant-home.styles.scss";

/**
 * The home page should be accessible to the admin of the restaurant.
 */
const RestaurantHome = () => {
  const navigate = useNavigate();
  return (
    <div className="restaurant-home-container">
      <div className="restaurant-home-cards">
        <div
          className="restaurant-home-card one"
          onClick={() => {
            navigate("order");
          }}
        >
          <span className="restaurant-home-cardmessage">
            <span className="restaurant-home-cardtitle">Orders</span>
            <br />
            Start a Tableside or Takeaway order
          </span>
        </div>
        <div
          className="restaurant-home-card two"
          onClick={() => {
            navigate("current");
          }}
        >
          <span className="restaurant-home-cardmessage">
            <span className="restaurant-home-cardtitle">Current</span>
            <br />
            Look at what you are serving at this moment
          </span>
        </div>
        <div
          className="restaurant-home-card three"
          onClick={() => {
            navigate("kitchen");
          }}
        >
          <span className="restaurant-home-cardmessage">
            <span className="restaurant-home-cardtitle">Kitchen</span>
            <br />
            Check kitchen status
          </span>
        </div>
        <div
          className="restaurant-home-card four"
          onClick={() => {
            navigate("inventory");
          }}
        >
          <span className="restaurant-home-cardmessage">
            <span className="restaurant-home-cardtitle">Inventory</span>
            <br />
            Know what you need tomorrow
          </span>
        </div>
      </div>
    </div>
  );
};
export default RestaurantHome;
